// extracted by mini-css-extract-plugin
module.exports = {"metrics":"BrandPage_metrics__3GXDe","brandHeader":"BrandPage_brandHeader__2oaff","container":"BrandPage_container__3S__P"};